import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function openMissionToStaffTravelExpenses(missionToStaffId: number) {
  return restApiClient
    .url(constructApiUrl(API.missionToStaffs.openTravelExpenses.url, { id: missionToStaffId }))
    .post()
}
